/* gut foods section behaviours (gf-). Each section root carries data-gf="<name>".
   The scroll engine (scrollcraft.js) is loaded lazily, only when a gf section needs it. */
import { CartLinesUpdateEvent } from '@shopify/events';

const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const small = () => matchMedia('(max-width: 980px)').matches;
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const map = (p, a, b) => clamp((p - a) / (b - a), 0, 1);
const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
const g1 = (n) => n.toFixed(1).replace('.', ',');
const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
const design = document.documentElement.classList.contains('shopify-design-mode');
const progressOf = (el) => parseFloat(el.style.getPropertyValue('--sc-p')) || 0;
/** rAF loop that ends when the element leaves the DOM (section re-render in the editor). */
function loop(el, fn) {
  const tick = () => { if (!el.isConnected) return; fn(); requestAnimationFrame(tick); };
  requestAnimationFrame(tick);
}

/* ---------------- scroll engine ---------------- */
let enginePromise;
function loadEngine() {
  if (window.ScrollCraft) return Promise.resolve(window.ScrollCraft);
  if (!enginePromise) {
    enginePromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = window.gfAssets && window.gfAssets.scrollcraft;
      s.onload = () => resolve(window.ScrollCraft);
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return enginePromise;
}
let mountTimer;
function mountEngine() {
  if (!document.querySelector('[data-sc-act], [data-sc-in]')) return;
  clearTimeout(mountTimer);
  mountTimer = setTimeout(async () => {
    const SC = await loadEngine();
    (SC.instances || []).splice(0).forEach((i) => i && i.destroy && i.destroy());
    if (reduce || small()) {
      $$('[data-gf-span-mobile]').forEach((el) => small() && el.setAttribute('data-sc-span', el.dataset.gfSpanMobile));
    }
    if (reduce) {
      $$('[data-gf-calm]').forEach((s) => {
        s.removeAttribute('data-sc-act');
        const st = s.querySelector('[data-sc-stage]');
        if (st) st.removeAttribute('data-sc-stage');
      });
    }
    SC.mount(document.body);
  }, 60);
}

/* ---------------- Biss ---------------- */
function bite(root) {
  const lis = $$('.gf-zl li', root), hs = $$('.gf-hs', root), ings = $$('.gf-ing', root);
  const frames = $$('.gf-frame', root), barx = $('.gf-barx', root), stage = $('.gf-studio', root);
  let picked = -1, shown = -2;
  const n = lis.length || 1;
  const th = lis.map((_, i) => 0.5 + (0.3 * i) / Math.max(1, n - 1));
  const setCur = (i) => {
    lis.forEach((l) => l.classList.toggle('cur', +l.dataset.i === i));
    hs.forEach((h) => h.classList.toggle('cur', +h.dataset.i === i));
    ings.forEach((g) => g.classList.toggle('lit', +g.dataset.i === i));
  };
  const pick = (i) => {
    picked = i;
    lis.forEach((l) => +l.dataset.i <= i && l.classList.add('on'));
    hs.forEach((h) => +h.dataset.i <= i && h.classList.add('on'));
    setCur(i);
  };
  hs.forEach((h) => h.addEventListener('click', () => pick(+h.dataset.i)));
  ings.forEach((g) => g.addEventListener('click', () => pick(+g.dataset.i)));
  lis.forEach((l) => {
    l.addEventListener('click', () => pick(+l.dataset.i));
    l.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(+l.dataset.i); } });
  });
  if (reduce || design || !root.hasAttribute('data-sc-act')) {
    hs.forEach((h) => h.classList.add('on')); lis.forEach((l) => l.classList.add('on'));
    if (barx) barx.style.opacity = 1;
    frames.forEach((f) => (f.style.opacity = 0));
    ings.forEach((g) => (g.style.opacity = 1));
    if (design) setCur(lis.length - 1);
    return;
  }
  let geo = [];
  const measure = () => {
    if (!barx) return;
    const off = (el) => { let x = 0, y = 0; while (el && el !== stage) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; } return [x, y]; };
    const [bl, bt] = off(barx), bx = bl + barx.offsetWidth / 2, by = bt + barx.offsetHeight / 2;
    geo = ings.map((g) => { const [gl, gt] = off(g); return { dx: bx - (gl + g.offsetWidth / 2), dy: by - (gt + g.offsetHeight / 2), d: +g.dataset.d }; });
  };
  measure(); addEventListener('resize', measure); addEventListener('load', measure);
  let lp = -1;
  loop(root, () => {
    const p = progressOf(root);
    if (Math.abs(p - lp) < 0.0002) return;
    lp = p;
    const k = [1, map(p, 0.08, 0.16), map(p, 0.2, 0.28), map(p, 0.32, 0.4)], c = ease(map(p, 0.4, 0.48));
    frames.forEach((f, i) => { f.style.opacity = ((k[i] ?? 1) * (1 - c)).toFixed(3); f.style.transform = 'scale(' + (1 + p * 0.05 + c * 0.06).toFixed(3) + ')'; });
    if (barx) { barx.style.opacity = c.toFixed(3); barx.style.transform = 'translateY(' + ((1 - c) * 30).toFixed(1) + 'px) scale(' + (0.86 + c * 0.14).toFixed(3) + ')'; }
    const drift = map(p, 0.8, 1);
    ings.forEach((g, i) => {
      const G = geo[i]; if (!G) return;
      const t = ease(map(p, th[i] - 0.05, th[i] + 0.04)), q = 1 - t, depth = [0.55, 1, 1.6][G.d] || 1;
      g.style.opacity = t.toFixed(3);
      g.style.transform = 'translate3d(' + (G.dx * q * 0.86).toFixed(1) + 'px,' + (G.dy * q * 0.86 - drift * 20 * depth).toFixed(1) + 'px,0) scale(' + (0.3 + t * 0.7).toFixed(3) + ') rotate(' + (q * (i % 2 ? 16 : -16)).toFixed(1) + 'deg)';
    });
    let cur = -1;
    th.forEach((v, i) => { const on = p >= v; lis[i] && lis[i].classList.toggle('on', on || i <= picked); hs[i] && hs[i].classList.toggle('on', on || i <= picked); if (on) cur = i; });
    if (picked < 0 && cur !== shown) { shown = cur; setCur(cur); }
    if (stage) {
      stage.setAttribute('data-sc-verify-state', p < 0.08 ? 'still' : p < 0.5 ? 'open-' + Math.round(p * 40) : p < 0.84 ? 'ing-' + cur + '-' + Math.round(p * 40) : 'hold');
      stage.setAttribute('data-sc-verify-hold', p < 0.08 || p >= 0.84 ? 'true' : 'false');
    }
  });
}

/* ---------------- Reels + Bewertungen ---------------- */
function voices(root) {
  const rail = $('.gf-lx-rail', root);
  const step = (d) => { const c = rail && rail.firstElementChild; if (c) rail.scrollBy({ left: d * (c.offsetWidth + 16), behavior: reduce ? 'auto' : 'smooth' }); };
  const prev = $('[data-gf-prev]', root), next = $('[data-gf-next]', root);
  prev && prev.addEventListener('click', () => step(-1));
  next && next.addEventListener('click', () => step(1));

  const reels = $$('.gf-reel', root), vids = reels.map((r) => r.querySelector('video'));
  const vm = $('.gf-vmodal', root);
  if (!vm || !reels.length) return;
  document.body.appendChild(vm); // escape transformed ancestors so position:fixed covers the viewport
  const vmv = $('video', vm), vmClose = $('.gf-vm-close', vm), vmProd = $('.gf-vm-prod', vm);
  let lastFocus = null;
  const openVid = (i) => {
    lastFocus = document.activeElement; vids.forEach((v) => v && v.pause());
    const src = vids[i].dataset.full || vids[i].currentSrc || vids[i].querySelector('source').src;
    vmv.src = src; vmv.poster = vids[i].getAttribute('poster') || ''; vmv.muted = false; vmv.currentTime = 0;
    vm.hidden = false; document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => vm.classList.add('on'));
    vmv.play().catch(() => {}); vmClose.focus();
  };
  const closeVid = () => {
    vmv.pause(); vm.classList.remove('on'); document.documentElement.style.overflow = '';
    setTimeout(() => { vm.hidden = true; vmv.removeAttribute('src'); vmv.load(); }, 200);
    if (lastFocus) lastFocus.focus();
  };
  reels.forEach((r, i) => r.querySelector('.play').addEventListener('click', () => openVid(i)));
  vmClose.addEventListener('click', closeVid);
  vm.addEventListener('click', (e) => { if (e.target === vm) closeVid(); });
  document.addEventListener('keydown', (e) => {
    if (vm.hidden) return;
    if (e.key === 'Escape') closeVid();
    if (e.key === 'Tab') {
      const f = [vmClose, vmv, vmProd].filter(Boolean), k = f.indexOf(document.activeElement);
      if (e.shiftKey && k <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && k === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
  });
  vmProd && vmProd.addEventListener('click', () => {
    closeVid();
    const target = vmProd.dataset.target && document.querySelector(vmProd.dataset.target);
    if (!target) { if (vmProd.dataset.url) location.href = vmProd.dataset.url; return; }
    setTimeout(() => {
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      setTimeout(() => { const b = document.querySelector('.product-information [name="add"], .product-information button[type="submit"]'); b && b.focus({ preventScroll: true }); }, 700);
    }, 220);
  });
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target;
      if (e.intersectionRatio >= 0.6 && vm.hidden) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(() => {}); } else v.pause();
    }), { threshold: [0, 0.6] });
    vids.forEach((v) => v && io.observe(v));
  }
  // Fächer-Effekt: Karten liegen gestapelt, beim Hineinscrollen legen sie sich nebeneinander
  const reelRail = $('.gf-reel-rail', root);
  if (reduce || design || !reelRail) return;
  let lpr = -1, base = [];
  const measure = () => {
    const rr = reelRail.getBoundingClientRect(), vw = Math.min(innerWidth, rr.right) - Math.max(0, rr.left), cx = Math.max(0, rr.left) + vw / 2;
    base = reels.map((r) => { const b = r.getBoundingClientRect(); return cx - (b.left + b.width / 2); });
  };
  addEventListener('resize', () => { reels.forEach((r) => (r.style.transform = 'none')); measure(); lpr = -1; });
  measure();
  loop(root, () => {
    const top = reelRail.getBoundingClientRect().top, p = clamp((innerHeight * 0.96 - top) / (innerHeight * 0.55), 0, 1);
    if (Math.abs(p - lpr) < 0.001) return;
    lpr = p; const t = ease(p), q = 1 - t, n = reels.length;
    reels.forEach((r, i) => {
      const k = i - (n - 1) / 2;
      r.style.transform = q < 0.001 ? 'none' : 'translate3d(' + ((base[i] || 0) * q * 0.9 + k * 26 * q).toFixed(1) + 'px,' + (Math.abs(k) * 22 * q + 60 * q).toFixed(1) + 'px,0) rotate(' + (k * 11 * q).toFixed(2) + 'deg) scale(' + (1 - 0.12 * q).toFixed(3) + ')';
      r.style.zIndex = n - Math.round(Math.abs(k) * 2);
    });
  });
}

/* ---------------- 30 g Teller ---------------- */
function plate(root) {
  const plateEl = $('.gf-plate', root), rows = $$('.gf-row', root);
  const target = parseFloat(root.dataset.target) || 30, avg = parseFloat(root.dataset.avg) || 19;
  const foods = rows.map((r, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'gf-food'; b.style.setProperty('--a', (i * (360 / rows.length)) + 'deg');
    b.setAttribute('aria-label', r.dataset.name || '');
    if (r.dataset.img) { const im = new Image(); im.src = r.dataset.img; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
    b.addEventListener('click', () => r.click());
    plateEl.appendChild(b);
    return b;
  });
  const sumEl = $('[data-gf-sum]', root), sumM = $('[data-gf-sum-m]', root), barM = $('[data-gf-bar-m]', root), ver = $('[data-gf-verdict]', root), arc = $('.sum', root);
  let started = false;
  const day = () => {
    let s = 0;
    rows.forEach((r, i) => { const on = r.getAttribute('aria-pressed') === 'true'; if (on) s += parseFloat(r.dataset.g); foods[i].classList.toggle('on', on && started); foods[i].setAttribute('aria-pressed', on); });
    s = Math.round(s * 10) / 10; const show = started ? s : 0;
    sumEl.textContent = g1(show); if (sumM) sumM.textContent = g1(s); if (barM) barM.style.width = Math.min(100, (s / target) * 100) + '%';
    arc.style.strokeDasharray = Math.min(100, (show / target) * 100).toFixed(1) + ' 100'; arc.classList.toggle('done', show >= target);
    const d = root.dataset, fill = (tpl, a, b) => (tpl || '').replace('[summe]', g1(a)).replace('[rest]', g1(b)).replace('[ziel]', target);
    ver.textContent = !started ? '' : s >= target ? fill(d.tDone || 'Geschafft: [summe] g, [rest] g über der Empfehlung.', s, s - target) : s === 0 ? (d.tEmpty || 'Tippe an, was du heute isst.') : fill(d.tOpen || 'Noch [rest] g bis [ziel] g.', s, target - s);
  };
  rows.forEach((r) => r.addEventListener('click', () => { started = true; r.setAttribute('aria-pressed', r.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); day(); }));
  const start = () => {
    if (plateEl.classList.contains('seen')) return;
    plateEl.classList.add('seen'); $('.avg', root).style.strokeDasharray = ((avg / target) * 100).toFixed(1) + ' 100';
    setTimeout(() => { started = true; day(); }, reduce || design ? 0 : 1500);
  };
  day();
  if ('IntersectionObserver' in window && !reduce && !design) {
    new IntersectionObserver((es, o) => es.forEach((e) => { if (e.isIntersecting) { start(); o.disconnect(); } }), { threshold: 0.45 }).observe(plateEl);
  } else start();
}

/* ---------------- Akazien-Weg ---------------- */
function acacia(root) {
  const sts = $$('.gf-st', root);
  if (reduce || design) return;
  let lp = -1;
  loop(root, () => {
    const p = progressOf(root);
    if (Math.abs(p - lp) < 0.0005) return;
    lp = p;
    sts.forEach((s, i) => { const t = i === 0 ? 1 : ease(map(p, i * 0.18 - 0.12, i * 0.18 + 0.06)); s.style.setProperty('--o', (0.55 + 0.45 * t).toFixed(3)); s.style.setProperty('--ty', ((1 - t) * 26).toFixed(1) + 'px'); });
  });
}

/* ---------------- Story-Slideshow ---------------- */
function story(root) {
  const card = $('.gf-story-card', root); if (!card) return;
  const sl = $$('.gf-slide', card), bars = $$('.gf-story-bars i', card), pp = $('.gf-story-pp', card), cnt = $('[data-gf-count]', root);
  if (!sl.length) return;
  const DUR = (parseFloat(root.dataset.seconds) || 6.5) * 1000;
  let cur = 0, el = 0, inView = false, userPaused = reduce || design, hover = false, ended = false;
  const show = (i) => {
    i = (i + sl.length) % sl.length; ended = false;
    sl.forEach((s, k) => { const on = k === i; s.classList.toggle('on', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
    bars.forEach((b, k) => { b.classList.toggle('done', k < i); b.firstElementChild.style.width = k < i ? '100%' : '0'; });
    const nx = sl[(i + 1) % sl.length].querySelector('img'); if (nx && nx.loading === 'lazy') nx.loading = 'eager';
    cur = i; el = 0; if (cnt) cnt.textContent = 'Bild ' + (i + 1) + ' von ' + sl.length;
  };
  const running = () => inView && !userPaused && !hover && !ended && !document.hidden;
  const setPP = () => {
    const p = userPaused || ended;
    pp.setAttribute('aria-label', ended ? 'Story nochmal ansehen' : p ? 'Slideshow abspielen' : 'Slideshow pausieren');
    pp.querySelector('[data-i="play"]').hidden = !p; pp.querySelector('[data-i="pause"]').hidden = p;
  };
  let last = performance.now();
  loop(root, () => {
    const now = performance.now(), dt = now - last; last = now;
    if (!running()) return;
    el += dt; const f = Math.min(el / DUR, 1); bars[cur].firstElementChild.style.width = (f * 100).toFixed(1) + '%';
    if (f >= 1) { if (cur < sl.length - 1) show(cur + 1); else { ended = true; setPP(); } }
  });
  $('.gf-story-tap.next', card).addEventListener('click', () => { show(cur + 1); setPP(); });
  $('.gf-story-tap.prev', card).addEventListener('click', () => { show(cur - 1); setPP(); });
  pp.addEventListener('click', () => { if (ended) { show(0); userPaused = false; } else userPaused = !userPaused; setPP(); });
  card.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1); setPP(); } if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1); setPP(); } });
  if (matchMedia('(hover:hover)').matches) { card.addEventListener('pointerenter', () => (hover = true)); card.addEventListener('pointerleave', () => (hover = false)); }
  let sx = null;
  card.addEventListener('pointerdown', (e) => (sx = e.clientX));
  card.addEventListener('pointerup', (e) => { if (sx === null) return; const dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 45) { show(cur + (dx < 0 ? 1 : -1)); setPP(); card.dataset.swiped = '1'; setTimeout(() => delete card.dataset.swiped, 50); } });
  card.addEventListener('click', (e) => { if (card.dataset.swiped) { e.stopPropagation(); e.preventDefault(); } }, true);
  if ('IntersectionObserver' in window) new IntersectionObserver((es) => (inView = es[0].intersectionRatio >= 0.5), { threshold: [0, 0.5] }).observe(card);
  else inView = true;
  setPP(); show(0);
}

/* ---------------- Genussmomente ---------------- */
function moments(root) {
  const cards = $$('.gf-mcard', root), dots = $$('.gf-dots i', root), st = $('[data-sc-stage]', root);
  if (reduce || design || !root.hasAttribute('data-sc-act')) return;
  const n = cards.length, span = n > 1 ? 0.76 / (n - 1) : 1;
  const cardT = (i, p) => (i === 0 ? 1 : ease(map(p, (i - 1) * span + 0.1, (i - 1) * span + 0.1 + span * 0.9)));
  let lp = -1;
  loop(root, () => {
    const p = progressOf(root);
    if (Math.abs(p - lp) < 0.0005) return;
    lp = p; let act = 0;
    cards.forEach((c, i) => {
      const t = cardT(i, p); let below = 0; for (let j = i + 1; j < n; j++) below += cardT(j, p);
      if (t > 0.5) act = i;
      c.style.transform = 'translateY(' + ((1 - t) * 112).toFixed(2) + '%) rotate(' + ((1 - t) * (i % 2 ? 6 : -6) + (i ? (i % 2 ? 1.2 : -1.2) : 0)).toFixed(2) + 'deg) scale(' + (1 - below * 0.05).toFixed(3) + ')';
      c.style.zIndex = i + 1;
    });
    dots.forEach((d, i) => d.classList.toggle('on', i === act));
    if (st) { st.setAttribute('data-sc-verify-state', 'card-' + act + '-' + Math.round(p * 30)); st.setAttribute('data-sc-verify-hold', p > 0.86 ? 'true' : 'false'); }
  });
}

/* ---------------- Tabs ---------------- */
function tabs(root) {
  const t = $$('[role=tab]', root);
  const sel = (x, focus) => { t.forEach((y) => { const on = y === x; y.setAttribute('aria-selected', on); y.tabIndex = on ? 0 : -1; const pnl = root.querySelector('#' + y.getAttribute('aria-controls')); if (pnl) pnl.hidden = !on; }); if (focus) x.focus(); };
  t.forEach((x, i) => {
    x.addEventListener('click', () => sel(x, true));
    x.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); sel(t[(i + 1) % t.length], true); } if (e.key === 'ArrowLeft') { e.preventDefault(); sel(t[(i - 1 + t.length) % t.length], true); } });
  });
}

/* ---------------- Duo: beide Produkte in den Warenkorb ---------------- */
function bundle(root) {
  $$('[data-gf-add]', root).forEach((btn) => btn.addEventListener('click', async () => {
    const items = JSON.parse(btn.dataset.gfAdd || '[]'); if (!items.length) return;
    btn.disabled = true;
    const lines = items.map((it) => ({ merchandiseId: String(it.id), quantity: it.quantity }));
    let resolve, reject; const promise = new Promise((a, b) => { resolve = a; reject = b; });
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines, promise }));
    try {
      const root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const r = await fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) throw new Error('add failed');
      const cart = await (await fetch(root_ + 'cart.js')).json();
      resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'gf-bundle', itemCount: items.length } });
      btn.textContent = btn.dataset.done || btn.textContent;
    } catch (e) { reject(e); location.href = '/cart'; }
    finally { btn.disabled = false; }
  }));
}


/* ---------------- E-Mail-Popup ---------------- */
function popup(root) {
  const pop = $('.gf-pop', root), teaser = $('.gf-pop-teaser', root);
  if (!pop) return;
  const KEY = 'gf-pop', days = parseFloat(root.dataset.days) || 7, delay = (parseFloat(root.dataset.delay) || 45) * 1000;
  const store = { get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }, set(v) { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(this.get(), v))); } catch (e) {} } };
  const st = store.get();
  const success = !!$('[data-gf-pop-success]', root);
  let lastFocus = null, isOpen = false;
  const showTeaser = (on) => { if (teaser) teaser.hidden = !on || store.get().done || store.get().noTeaser; };
  const open = () => {
    if (isOpen) return; isOpen = true; lastFocus = document.activeElement;
    pop.hidden = false; requestAnimationFrame(() => pop.classList.add('on')); showTeaser(false);
    const f = $('input[type=email]', pop) || $('.gf-btn', pop); f && f.focus({ preventScroll: true });
    store.set({ seen: Date.now() });
  };
  const close = () => {
    if (!isOpen) return; isOpen = false; pop.classList.remove('on');
    setTimeout(() => (pop.hidden = true), 250);
    store.set({ closed: Date.now() }); showTeaser(true);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  $$('[data-gf-pop-close]', root).forEach((b) => b.addEventListener('click', close));
  pop.addEventListener('click', (e) => { if (e.target === pop) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen) close(); });
  if (teaser) {
    teaser.addEventListener('click', (e) => { if (e.target.closest('[data-gf-teaser-close]')) { e.stopPropagation(); store.set({ noTeaser: true }); teaser.hidden = true; return; } open(); });
  }
  const form = $('form', pop);
  form && form.addEventListener('submit', () => store.set({ submitted: Date.now() }));
  if (success) { store.set({ done: true }); open(); return; }
  if (root.dataset.preview === 'true') { open(); return; }
  if (root.dataset.subscribed === 'true' || st.done) return;
  const recently = st.closed && Date.now() - st.closed < days * 864e5;
  if (recently) { showTeaser(true); return; }
  const timer = setTimeout(open, delay);
  if (root.dataset.exit === 'true') {
    const armAt = Date.now() + 8000;
    const onLeave = (e) => { if (Date.now() < armAt || e.relatedTarget || e.clientY > 8) return; clearTimeout(timer); document.removeEventListener('mouseout', onLeave); open(); };
    if (matchMedia('(hover:hover)').matches) document.addEventListener('mouseout', onLeave);
    else {
      let lastY = scrollY, lastT = Date.now();
      const onScroll = () => { const now = Date.now(), dy = lastY - scrollY, v = dy / Math.max(1, now - lastT); lastY = scrollY; lastT = now;
        if (now > armAt + 7000 && v > 2.5 && scrollY > 600) { clearTimeout(timer); removeEventListener('scroll', onScroll); open(); } };
      addEventListener('scroll', onScroll, { passive: true });
    }
  }
}

/* ---------------- lange Beschreibung aufklappen ---------------- */
function desc(root) {
  const b = $('[data-gf-desc]', root), t = $('[data-gf-desc-toggle]', root);
  if (!b || !t) return;
  if (b.scrollHeight <= b.clientHeight + 40) { b.classList.remove('is-collapsed'); t.hidden = true; return; }
  t.addEventListener('click', () => { const open = b.classList.toggle('is-collapsed') === false; t.setAttribute('aria-expanded', open); t.hidden = open; });
}

/* ---------------- Bildfolge mit Schritten (Glas) ---------------- */
function dissolve(root) {
  const frames = $$('.gf-dis-frame', root), steps = $$('.gf-dis-steps li', root), prod = $('.gf-dis-prod', root);
  if (!frames.length) return;
  const setStep = (i) => steps.forEach((s, k) => s.classList.toggle('on', k === Math.min(i, steps.length - 1)));
  steps.forEach((s, k) => s.addEventListener('click', () => { frames.forEach((f, j) => { f.classList.toggle('on', j === Math.min(k, frames.length - 1)); f.style.opacity = ''; }); setStep(k); }));
  if (reduce || design || !root.hasAttribute('data-sc-act')) return;
  const n = frames.length; let lp = -1;
  loop(root, () => {
    const p = progressOf(root);
    if (Math.abs(p - lp) < 0.0005) return;
    lp = p;
    const x = map(p, 0.06, 0.86) * (n - 1);
    frames.forEach((f, i) => { const o = clamp(1 - Math.abs(x - i), 0, 1); f.style.opacity = (i === 0 && x <= 0 ? 1 : o).toFixed(3); f.style.transform = 'scale(' + (1 + p * 0.04).toFixed(3) + ')'; });
    setStep(Math.round(x * (steps.length - 1) / Math.max(1, n - 1)));
    if (prod) prod.style.setProperty('--gf-dis-y', ((0.5 - p) * 40).toFixed(1) + 'px');
  });
}

/* ---------------- Infografik ---------------- */
function countUp(el) {
  const to = parseFloat(el.dataset.count); if (isNaN(to) || el.dataset.done) return; el.dataset.done = '1';
  const dec = String(el.dataset.count).includes('.') ? 1 : 0, t0 = performance.now(), dur = reduce ? 0 : 1100;
  const step = (t) => { if (el._tw && el._tw > t0) return; const k = dur ? Math.min(1, (t - t0) / dur) : 1; el.textContent = (to * ease(k)).toFixed(dec).replace('.', ','); if (k < 1) requestAnimationFrame(step); };
  requestAnimationFrame(step);
}
function fiberstory(root) {
  const chs = $$('.gf-fs-ch', root), nav = $$('.gf-fs-nav li', root);
  if (!chs.length) return;
  const fmt = (v) => String(Math.round(v * 10) / 10).replace('.', ',');
  const tween = (el, from, to) => {
    const t0 = performance.now(), dur = 900; el._tw = t0;
    const step = (t) => { if (el._tw !== t0) return; const k = Math.min(1, (t - t0) / dur); el.textContent = fmt(from + (to - from) * ease(k)); if (k < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  };
  // Each chapter has 1 step, a compare chapter with a fill has 2 (gap, then filled).
  const units = []; chs.forEach((c, k) => { const n = parseInt(c.dataset.steps || '1', 10); for (let s = 0; s < n; s++) units.push([k, s]); });
  const setStep = (c, s) => {
    const was = c.classList.contains('s1'); c.classList.toggle('s1', s === 1);
    const el = $('[data-to]', c); if (!el || was === (s === 1)) return;
    const a = parseFloat(el.dataset.count), b = parseFloat(el.dataset.to);
    el.dataset.done = '1'; s === 1 ? tween(el, a, b) : tween(el, b, a);
  };
  const show = (u) => {
    const [i, s] = units[u];
    chs.forEach((c, k) => { const on = k === i; c.classList.toggle('on', on); if (on) { $$('[data-count]', c).forEach((el) => { if (!(s === 1 && el.dataset.to)) countUp(el); }); setStep(c, s); } });
    nav.forEach((l, k) => l.classList.toggle('on', k === u));
  };
  if (reduce || design || !root.hasAttribute('data-sc-act')) {
    $$('[data-to]', root).forEach((el) => { el.dataset.done = '1'; el.textContent = fmt(parseFloat(el.dataset.to)); });
    chs.forEach((c) => $$('[data-count]', c).forEach(countUp));
    return;
  }
  let cur = -1;
  loop(root, () => {
    const p = progressOf(root), u = Math.min(units.length - 1, Math.floor(map(p, 0.04, 0.96) * units.length * 0.9999));
    if (u !== cur) { cur = u; show(u); }
  });
}
/* ---------------- Zoom-Reise ---------------- */
function zoom(root) {
  const ls = $$('.gf-zm-layer', root), caps = $$('.gf-zm-cap', root);
  if (!ls.length) return;
  if (reduce || design || !root.hasAttribute('data-sc-act')) {
    let i = 0; if (ls.length > 1 && !design) setInterval(() => { i = (i + 1) % ls.length; ls.forEach((l, k) => l.classList.toggle('on', k === i)); caps.forEach((c, k) => c.classList.toggle('on', k === i)); }, 4500);
    return;
  }
  const n = ls.length; let lp = -1, cc = -1;
  loop(root, () => {
    const p = progressOf(root);
    if (Math.abs(p - lp) < 0.0004) return;
    lp = p;
    const x = map(p, 0.02, 0.92) * (n - 1);
    ls.forEach((l, i) => {
      const d = x - i; // <0: upcoming, 0..1: leaving
      let o, s;
      if (d <= -1) { o = 0; s = 0.7; }
      else if (d < 0) { const t = d + 1; o = ease(t); s = 0.7 + 0.3 * ease(t); }
      else if (d < 1) { o = i === n - 1 ? 1 : 1 - ease(clamp((d - 0.35) / 0.65, 0, 1)); s = 1 + 1.6 * ease(d); }
      else { o = i === n - 1 ? 1 : 0; s = 2.6; }
      if (i === n - 1 && d >= 0) s = 1 + 0.08 * Math.min(1, d);
      l.style.opacity = o.toFixed(3); l.style.transform = 'scale(' + s.toFixed(3) + ')'; l.style.zIndex = d < 0 ? 2 : 1;
    });
    const c = Math.min(n - 1, Math.round(x));
    if (c !== cc) { cc = c; caps.forEach((cp, k) => cp.classList.toggle('on', k === c)); }
  });
}

function manifesto(root) {
  if (reduce || design || !('IntersectionObserver' in window)) { root.classList.add('on'); return; }
  const io = new IntersectionObserver((es) => { es.forEach((e) => { if (e.isIntersecting) { root.classList.add('on'); io.disconnect(); } }); }, { threshold: 0.35 });
  io.observe(root);
}

function preview(root) {
  const pages = $$('.gf-ebp-page[data-full]', root), dlg = $('.gf-ebp-lb', root);
  if (!pages.length || !dlg) return;
  const img = $('img', dlg), cap = $('figcaption', dlg);
  let cur = 0;
  const show = (i) => { cur = (i + pages.length) % pages.length; const p = pages[cur]; img.src = p.dataset.full; img.alt = $('img', p)?.alt || ''; cap.textContent = p.dataset.cap || (cur + 1) + ' / ' + pages.length; };
  pages.forEach((p, i) => p.addEventListener('click', () => { show(i); dlg.showModal(); }));
  $('.gf-ebp-x', dlg).addEventListener('click', () => dlg.close());
  $('.gf-ebp-nav.prev', dlg).addEventListener('click', () => show(cur - 1));
  $('.gf-ebp-nav.next', dlg).addEventListener('click', () => show(cur + 1));
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') show(cur + 1); if (e.key === 'ArrowLeft') show(cur - 1); });
}

/* ---------------- Kaching checkbox upsells: show highlights when ticked ---------------- */
function upsellinfo(el) {
  let data; try { data = JSON.parse(el.textContent); } catch (e) { return; }
  if (!Array.isArray(data) || !data.length) return;
  const isKaching = (n) => { for (let x = n; x && x !== document.body; x = x.parentElement) { if (/kaching/i.test(x.tagName) || /kaching/i.test(typeof x.className === 'string' ? x.className : '')) return true; } return false; };
  const isOn = (box) => {
    if (box.matches('input')) return box.checked;
    if (box.hasAttribute('aria-checked')) return box.getAttribute('aria-checked') === 'true';
    return /(^|[\s_-])(checked|selected|active)(\s|$)/i.test(box.className);
  };
  const itemOf = (box, d) => { let x = box; for (let k = 0; k < 7 && x.parentElement; k++) { x = x.parentElement; if (x.textContent.includes(d.match)) return x; } return null; };
  const panelFor = (d) => {
    const p = document.createElement('div'); p.className = 'gf-uh'; p.dataset.gfUh = d.match;
    const ul = document.createElement('ul');
    d.highlights.forEach((t) => { const li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
    p.appendChild(ul); return p;
  };
  const sync = () => {
    let boxes; try { boxes = $$('input[type="checkbox"], [role="checkbox"], [class*="checkbox"]:not(:has(input[type="checkbox"], [role="checkbox"]))'); } catch (e) { boxes = $$('input[type="checkbox"], [role="checkbox"]'); }
    boxes.forEach((box) => {
      if (box.closest('.gf-uh') || !isKaching(box)) return;
      if (!box.matches('input, [role="checkbox"]') && box.parentElement?.closest('[class*="checkbox"]')) return;
      const d = data.find((x) => itemOf(box, x));
      if (!d) return;
      const item = itemOf(box, d);
      let p = box._gfUh;
      if (!p) { p = panelFor(d); box._gfUh = p; }
      if (p.previousElementSibling !== item) item.after(p);
      const on = isOn(box);
      if (p.classList.contains('on') !== on) p.classList.toggle('on', on);
    });
  };
  let raf = 0; const later = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; sync(); }); };
  document.addEventListener('change', () => setTimeout(sync, 0), true);
  document.addEventListener('click', () => setTimeout(sync, 60), true);
  const ours = (n) => n.nodeType === 1 && !!n.closest?.('.gf-uh');
  new MutationObserver((ms) => { if (ms.some((m) => m.type === 'attributes' ? !ours(m.target) : ![...m.addedNodes, ...m.removedNodes].every((n) => n.nodeType === 1 && n.classList.contains('gf-uh')))) later(); }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked', 'class'] });
  sync();
}

const INIT = { bite, voices, plate, acacia, story, moments, tabs, bundle, popup, desc, dissolve, fiberstory, zoom, manifesto, preview, upsellinfo };
function init(scope = document) {
  $$('[data-gf]', scope).forEach((el) => {
    if (el.dataset.gfReady) return;
    el.dataset.gfReady = '1';
    (el.dataset.gf || '').split(' ').forEach((k) => { try { INIT[k] && INIT[k](el); } catch (e) { console.error('[gf]', k, e); } });
  });
  mountEngine();
}
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
document.addEventListener('shopify:section:unload', () => mountEngine());
